import { AgentThreadVo } from "@/api";
import { convertFilePathToUrl } from "@/util/convertFilePathToUrl";
import { formatTime } from "@/util/datetime";
import { BlurBackgroundContainer } from "../BlurBackgroundContainer";
import defaultImage from "./default.jpg";
import styles from "./index.module.css";

type ThreadLike = Pick<
  AgentThreadVo,
  "id" | "title" | "imageUrl" | "updateTime"
>;

interface IProps {
  thread: ThreadLike;
}

export function ThreadListItem(props: IProps) {
  const { thread } = props;
  const imageUrl = convertFilePathToUrl(thread.imageUrl || "", {
    level: "medium",
  });

  return (
    <div className={styles.wrapper}>
      <BlurBackgroundContainer
        className="w-full aspect-video rounded-xl"
        mediaType="image"
        src={imageUrl || defaultImage.src}
        previewSrc={imageUrl || defaultImage.src}
        alt={thread.title || "Thread thumbnail"}
        hoverScale
      />
      <div className={styles.footer}>
        <div className={styles.title}>{thread.title}</div>
        <div className={styles.description}>
          {thread.updateTime && `Last refined ${formatTime(thread.updateTime)}`}
        </div>
      </div>
    </div>
  );
}
